module.exports = __webpack_public_path__ + "static/Davey-a8d92741688a4b3d99631b7e8ecf4b7d.jpg";